<template xmlns="http://www.w3.org/1999/html">
  <div class="w-full">
    <Panel header="Thêm dân cư vào tổ">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <!-- Download template button -->
        <section class="md:col-span-12">
          <Button
            label="Tải danh sách mẫu"
            severity="secondary"
            @click="downLoadFile()"
            icon="pi pi-cloud-download"
          />
        </section>

        <!-- File upload section -->
        <section class="md:col-span-12">
          <div
            class="rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
              class="mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3"
            >
              <div>
                <label class="m-0 text-[15px] font-bold text-slate-900"
                  >Tập tin danh sách dân cư</label
                >
                <div class="mt-1 text-[13px] font-medium text-slate-500">
                  XLSX, XLS (hỗ trợ chọn nhiều tập tin)
                </div>
              </div>
            </div>

            <div
              class="grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]"
            >
              <div
                class="flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5"
              >
                <span
                  class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700"
                >
                  <i class="pi pi-file-excel"></i>
                </span>
                <div class="min-w-0">
                  <div
                    class="truncate text-[15px] font-semibold text-slate-900"
                  >
                    {{
                      listFileName.length > 0
                        ? `Đã chọn ${listFileName.length} tập tin`
                        : "Chưa chọn tập tin"
                    }}
                  </div>
                  <div class="text-sm text-slate-500">
                    Có thể chọn nhiều tập tin cùng lúc
                  </div>
                </div>
              </div>

              <div class="flex shrink-0 flex-wrap gap-2 lg:justify-end">
                <Button
                  outlined
                  label="Đính kèm tập tin"
                  icon="pi pi-paperclip"
                  @click="selectFile()"
                  :disabled="loadingBar"
                />
                <Button
                  label="Đăng danh sách"
                  icon="pi pi-cloud-upload"
                  @click="upload()"
                  :loading="loadingBar"
                  :disabled="loadingBar || listFileName.length < 1"
                />
              </div>
            </div>
          </div>

          <form enctype="multipart/form-data">
            <input
              id="myFile"
              type="file"
              class="hidden"
              accept=".xlsx,.xls"
              name="files"
              multiple="multiple"
              v-on:change="fileChange($event.target.files)"
              :disabled="loadingBar"
            />
          </form>
        </section>

        <!-- File list section -->
        <section class="md:col-span-12">
          <div
            class="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
          >
            <div
              class="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3"
            >
              <div>
                <div class="text-[15px] font-bold text-slate-900">
                  Tập tin đã chọn
                </div>
                <div class="text-[13px] font-medium text-slate-500">
                  Kiểm tra danh sách trước khi đăng danh sách.
                </div>
              </div>
            </div>

            <div v-if="listFileName.length > 0" class="overflow-x-auto">
              <table class="min-w-full divide-y divide-slate-200 text-[15px]">
                <thead
                  class="bg-slate-100 text-left text-xs font-bold uppercase text-slate-600"
                >
                  <tr>
                    <th class="px-4 py-3">Tập tin</th>
                    <th class="w-36 px-4 py-3">Dung lượng</th>
                    <th class="w-28 px-4 py-3 text-right">Thao tác</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-100 bg-white">
                  <tr
                    v-for="file in listFileName"
                    :key="file.nameFile"
                    class="transition hover:bg-teal-50/40"
                  >
                    <td class="px-4 py-3">
                      <div class="flex min-w-0 items-center gap-3">
                        <span
                          class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700"
                        >
                          <i class="pi pi-file-excel"></i>
                        </span>
                        <span class="min-w-0 truncate text-slate-900">{{
                          file.nameFile
                        }}</span>
                      </div>
                    </td>
                    <td class="px-4 py-3 text-slate-600">
                      {{ formatFileSize(file.value?.size) }}
                    </td>
                    <td class="px-4 py-3 text-right">
                      <Button
                        severity="danger"
                        label="Xóa"
                        icon="pi pi-trash"
                        @click="deleteFile(file.nameFile)"
                        class="!min-h-[36px] px-3 py-1.5"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="px-4 py-8 text-center">
              <span
                class="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-400"
              >
                <i class="pi pi-folder-open"></i>
              </span>
              <p class="mt-3 text-sm font-semibold text-slate-600">
                Chưa có tập tin nào được chọn.
              </p>
            </div>
          </div>
        </section>

        <!-- Error list section -->
        <section class="md:col-span-12" v-if="resDetail.failNumber > 0">
          <div
            class="overflow-hidden rounded-lg border border-red-200 bg-white shadow-[0_14px_34px_rgba(15,23,42,0.07)]"
          >
            <div
              class="flex flex-wrap items-center justify-between gap-4 border-b border-red-100 bg-red-50 px-4 py-4"
            >
              <div class="flex min-w-0 items-center gap-3">
                <span
                  class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-red-100 text-red-700"
                >
                  <i class="pi pi-exclamation-triangle text-lg"></i>
                </span>
                <div class="min-w-0">
                  <div class="text-[16px] font-extrabold text-slate-950">
                    Danh sách hồ sơ lỗi
                  </div>
                  <div class="mt-1 text-[13px] font-medium text-slate-600">
                    Kiểm tra và chỉnh sửa dữ liệu trong file trước khi đăng lại.
                  </div>
                </div>
              </div>
              <div class="flex flex-wrap items-center gap-2">
                <div
                  class="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-white px-3 py-1.5 text-sm font-extrabold text-emerald-700"
                >
                  <i class="pi pi-check-circle text-xs"></i>
                  {{ resDetail.successNumber }} hồ sơ thành công
                </div>
                <div
                  class="inline-flex items-center gap-2 rounded-full border border-red-200 bg-white px-3 py-1.5 text-sm font-extrabold text-red-700"
                >
                  <i class="pi pi-times-circle text-xs"></i>
                  {{ resDetail.failNumber }} hồ sơ lỗi
                </div>
              </div>
            </div>
            <DataTable
              :value="resDetail.listError"
              :paginator="true"
              stripedRows
              :rows="10"
              :rowsPerPageOptions="[10, 25, 50]"
              :rowHover="true"
              v-model:filters="filters"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :globalFilterFields="['fullName', 'phoneNumber']"
              currentPageReportTemplate="Có tổng số {totalRecords} dân cư lỗi"
              columnResizeMode="fit | expand"
            >
              <template #header>
                <div class="flex flex-wrap items-center justify-between gap-3">
                  <span class="relative inline-flex w-full max-w-[420px]">
                    <i
                      class="pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 block -translate-y-1/2 text-sm leading-none text-slate-400"
                    />
                    <InputText
                      class="!pl-8"
                      v-model="filters['global'].value"
                      placeholder="Tìm theo họ tên, số điện thoại hoặc nội dung lỗi"
                    />
                  </span>
                  <Button
                    type="button"
                    icon="pi pi-filter-slash"
                    label="Xoá lọc"
                    outlined
                    @click="clearFilter()"
                  />
                </div>
              </template>
              <Column field="fullName" header="Họ và tên" sortable>
                <template #body="{ data }">
                  <div class="min-w-[180px] font-bold text-slate-900">
                    {{ data.fullName || "Chưa có họ tên" }}
                  </div>
                </template>
              </Column>
              <Column field="phoneNumber" header="Số điện thoại" sortable>
                <template #body="{ data }">
                  <span
                    class="inline-flex min-w-[120px] items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-700"
                  >
                    <i class="pi pi-phone text-[11px] text-teal-700"></i>
                    {{ data.phoneNumber || "Trống" }}
                  </span>
                </template>
              </Column>
              <Column field="message" header="Thông báo" sortable>
                <template #body="{ data }">
                  <div
                    class="min-w-[320px] rounded-md border border-red-100 bg-red-50 px-3 py-2 text-[13px] font-semibold leading-5 text-red-700"
                  >
                    {{ data.message || "Dữ liệu không hợp lệ" }}
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
        </section>

        <!-- Create list button -->
        <section class="md:col-span-12" v-if="show">
          <Button
            label="Thêm danh sách dân cư"
            @click="createList()"
            icon="pi pi-plus-circle"
            :loading="loadingBarProcess"
            class="w-full"
          />
        </section>
      </div>
    </Panel>
  </div>

  <!--&lt;!&ndash;            <Button label="thuế" icon="pi pi-send" iconPos="left" @click="resendMessageNotification()" :disabled="listTax.length < 1"/>&ndash;&gt;-->
  <!--&lt;!&ndash;          </div>&ndash;&gt;-->
  <!--&lt;!&ndash;          <div class="flex min-w-0 flex-col md:col-span-4">&ndash;&gt;-->
  <!--&lt;!&ndash;            <Button label="Gửi thông báo thuế" icon="pi pi-send" iconPos="left" @click="resendMessageNotification()" :disabled="listTax.length < 1"/>&ndash;&gt;-->
  <!--&lt;!&ndash;          </div>&ndash;&gt;-->
  <!--          <div class="flex min-w-0 flex-col md:col-span-12">-->
  <!--          <DataTable-->
  <!--              :loading="isLoading"-->
  <!--              :value="listTax" :paginator="true" stripedRows :rows="10"-->
  <!--              :rowsPerPageOptions="[10,25,50]" :rowHover="true"-->
  <!--              v-model:filters="filters"-->
  <!--              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"-->
  <!--              :globalFilterFields="['fullName','phoneNumber','taxNumber','wardName']"-->
  <!--              currentPageReportTemplate="Có tổng số {totalRecords}" columnResizeMode="fit | expand">-->
  <!--            <template #header>-->
  <!--              <div class="flex flex-wrap items-center justify-between gap-3">-->
  <!--                <Button type="button" icon="pi pi-filter-slash" label="Xoá" outlined @click="clearFilter()" class="w-[6em]"/>-->
  <!--                <span class="relative inline-flex w-full max-w-[18em]">-->
  <!--                    <i class="pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" />-->
  <!--                  <InputText class="pl-9" v-model="filters['global'].value" placeholder="Tìm kiếm" />-->
  <!--                </span>-->
  <!--            </div>-->
  <!--          </template>-->
  <!--          <Column field="fullName" header="Họ và tên" sortable></Column>-->
  <!--          <Column field="phoneNumber" header="Số điện thoại" sortable></Column>-->
  <!--          <Column field="cccd" header="Cmnd/cccd" sortable></Column>-->
  <!--          <Column field="taxNumber" header="Mã số thuế" sortable></Column>-->
  <!--          <Column field="wardName" header="Phường" sortable></Column>-->
  <!--          <Column field="address" header="Địa chỉ" sortable></Column>-->
  <!--          <Column header="Số tiền" sortable>-->
  <!--            <template #body="slotProps">-->
  <!--              {{moneyValue(slotProps.data.price)}}-->
  <!--            </template>-->
  <!--          </Column>-->
  <!--            <Column header="Thời gian" sortable>-->
  <!--            <template #body="slotProps">-->
  <!--              {{formatDateTime(slotProps.data.time)}}-->
  <!--            </template>-->
  <!--          </Column>-->
  <!--          <Column header="Tình trạng" sortable class="w-[200px]">-->
  <!--            <template #body="slotProps">-->
  <!--&lt;!&ndash;              {{resultStatus(slotProps.data.status)}}&ndash;&gt;-->
  <!--              <div v-if="resultStatus(slotProps.data.status) == 'Đã nộp thuế'">-->
  <!--                <Button icon="pi pi-sync" iconPos="left" class="w-[200px]">-->
  <!--                  {{resultStatus(slotProps.data.status)}}-->
  <!--                </Button>-->
  <!--              </div>-->
  <!--              <div v-else>-->
  <!--                <Button icon="pi pi-sync" iconPos="left" severity="secondary" class="w-[200px]">-->
  <!--                  {{resultStatus(slotProps.data.status)}}-->
  <!--                </Button>-->
  <!--              </div>-->
  <!--            </template>-->
  <!--          </Column>-->
  <!--        </DataTable>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </TabPanel>-->

  <div class="w-full">
    <Dialog header="Đăng danh sách" v-model:visible="loadingBar">
      <div id="loading">
        <label>Đang đăng danh sách...</label>
        <ProgressBar mode="indeterminate" class="h-[0.3em]" />
      </div>
    </Dialog>
    <ConfirmDialog></ConfirmDialog>
  </div>
  <div class="w-full">
    <Dialog header="Đang xử lý" v-model:visible="loadingBarProcess">
      <div id="loadingProcess">
        <label>Đang thêm danh sách, vui lòng chờ...</label>
        <ProgressBar mode="indeterminate" class="h-[0.3em]" />
      </div>
    </Dialog>
    <ConfirmDialog></ConfirmDialog>
  </div>
  <div class="w-full">
    <Dialog header="Đang xử lý" v-model:visible="loadingExport">
      <div id="loadingExport">
        <label>Đang xuất dữ liệu, vui lòng chờ...</label>
        <ProgressBar mode="indeterminate" class="h-[0.3em]" />
      </div>
    </Dialog>
    <Dialog header="Đang xử lý" v-model:visible="sendMessage">
      <div id="sendMessage">
        <label>Đang gửi thông báo thuế, vui lòng chờ ....</label>
        <ProgressBar mode="indeterminate" class="h-[0.3em]" />
      </div>
    </Dialog>
    <ConfirmDialog></ConfirmDialog>
  </div>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useToast } from "@/ui/services/toast";
import axios from "axios";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { FileDetail } from "@/models/fileDetail.models";
import ZaloRepository from "@/services/ZaloRepository";
import Ward from "@/models/Ward.models";
import zaloRepository from "@/services/ZaloRepository";
import authRepository from "@/services/AuthRepository";
import { ImportTax } from "@/models/importTax";
import { TaxDetail } from "@/models/taxDetail";
import { FilterMatchMode } from "@/ui/services/api";
import moment from "moment";
import { TaxSearch } from "@/models/taxSearch";
import { ResDetail } from "@/models/resDetail";
import { ResDetailRegister } from "@/models/resDetailRegister";
import { ImportCivilGroup } from "@/models/importCivilGroup";

export default {
  setup() {
    const layout = ref("grid");
    const toast = useToast();
    const show = ref(false);
    const store = useStore();
    const router = useRouter();
    const fileName = ref("");
    const idEvent = ref(0);
    const minDate = ref(new Date());
    const listWard = ref([] as Ward[]);
    const ward = ref({} as Ward);
    const importCivilGroup = ref({} as ImportCivilGroup);
    const index = ref(0);
    const listTax = ref([] as TaxDetail[]);
    const listWardFilter = ref([]);
    const date = ref();
    const taxSearch = ref({} as TaxSearch);
    const downloadFile = ref(false);
    const adminPermission = ref(false);
    const sendMessage = ref(false);
    const resDetail = ref({} as ResDetailRegister);
    const res = ref("");

    if (!!!store.state.token) {
      router.push({
        name: "login",
      });
    }
    if (
      store.state.permission == "admin" ||
      store.state.permission == "district"
    ) {
      adminPermission.value = true;
    }
    zaloRepository
      .getListWard()
      .then((response) => {
        listWard.value = response.data;
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: err.response.data,
          life: 2000,
        });
      });

    // authRepository.getListTax()
    //     .then((response) => {
    //       listTax.value = response.data;
    //     })
    //     .catch(err => {
    //       toast.add({
    //         severity: 'error',
    //         summary: 'Lỗi',
    //         detail:err.response.data,
    //         life: 2000
    //       });
    //     });

    let listFileName = ref([] as FileDetail[]);
    const loadingBar = ref(false);
    const loadingBarProcess = ref(false);
    const loadingExport = ref(false);
    const fileChange = (fileList) => {
      fileName.value = fileList[0].name;
      listFileName.value = [];
      var leng = fileList.length;
      for (var i = 0; i < leng; i++) {
        var filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };
    const upload = () => {
      {
        var files = new FormData();
        listFileName.value.forEach((x) => {
          files.append("formFiles", x.value, x.nameFile);
        });
        loadingBar.value = true;
        axios
          .post(`/api/File/UploadFileTax`, files, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            importCivilGroup.value.link = response.data;
            loadingBar.value = false;
            listFileName.value = [];
            createList();
          })
          .catch((err) => {
            loadingBar.value = false;
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response?.data || "Tải danh sách không thành công",
              life: 2500,
            });
          });
      }
    };
    const createList = () => {
      loadingBarProcess.value = true;
      //importTax.value.idWard = index.value;
      console.log(
        "######## debug tax createList importTax: " +
          JSON.stringify(importCivilGroup.value),
      );
      authRepository
        .createListPeople(importCivilGroup.value)
        .then((response) => {
          resDetail.value = response.data;
          loadingBarProcess.value = false;
          if (resDetail.value.success) {
            res.value =
              "Đăng tải danh sách:" +
              "\n" +
              "Thành công: " +
              resDetail.value.successNumber +
              " dân cư vào tổ" +
              "\n" +
              ", Thất bại: " +
              resDetail.value.failNumber +
              " dân cư vào tổ";
          } else {
            res.value = "Đăng tải danh sách không thành công";
          }
          const successNumber = resDetail.value.successNumber || 0;
          const failNumber = resDetail.value.failNumber || 0;
          const hasSuccess = successNumber > 0;
          const hasFail = failNumber > 0;

          toast.add({
            severity: hasFail ? (hasSuccess ? "warn" : "error") : "success",
            summary: hasFail
              ? hasSuccess
                ? "Có hồ sơ lỗi"
                : "Không thành công"
              : "Thành công",
            detail: hasFail
              ? hasSuccess
                ? `Đã thêm ${successNumber} hồ sơ, ${failNumber} hồ sơ lỗi`
                : `Không thêm được hồ sơ nào, ${failNumber} hồ sơ lỗi`
              : `Đã thêm ${successNumber} hồ sơ thành công`,
            life: 4000,
          });
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 4000,
          });
          loadingBarProcess.value = false;
        });
    };
    const downLoadFile = () => {
      axios({
        url: "../api/File/downloadcivilgrouptemplate/",
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: response.data.type }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "DanCu.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2500,
          });
        });
    };
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    };

    const formatDateTime = (date) => {
      return moment(String(date)).format("YYYY");
    };

    const resultStatus = (status) => {
      if (status) return "Đã nộp thuế";
      else return "Chưa nộp thuế";
    };

    const moneyValue = (x) => {
      return Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(x);
    };

    const loadListTax = () => {
      listTax.value = [];
      authRepository
        .getListTaxWithYear(taxSearch.value)
        .then((response) => {
          listTax.value = response.data;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        });
    };

    const exportFile = () => {
      loadingExport.value = true;
      authRepository
        .exportListTax(listTax.value)
        .then((response) => {
          fileName.value = response.data;
          toast.add({
            severity: "success",
            summary: "Xuất dữ liệu",
            detail: "Xuất dữ liệu thành công",
            life: 2000,
          });
          loadingExport.value = false;
          downloadFile.value = true;
          // router.push({
          //   name: 'home'
          // });
        })
        .catch((err) => {
          loadingBar.value = false;
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        });
    };

    const downLoadFileExport = () => {
      axios({
        url: "../api/auth/downloadListTax/" + fileName.value,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: response.data.type }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "DanhSachThueDat.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2500,
          });
        });
    };

    const resendMessageNotification = () => {
      sendMessage.value = true;
      ZaloRepository.resendMessageTax(listTax.value)
        .then((response) => {
          sendMessage.value = false;
          toast.add({
            severity: "success",
            summary: "Gửi thông báo",
            detail: "Gửi thông báo thuế thành công",
            life: 2000,
          });
        })
        .catch((err) => {
          sendMessage.value = false;
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        });
    };

    const selectFile = () => {
      const fileInput = document.getElementById("myFile") as HTMLInputElement;
      if (fileInput) {
        fileInput.click();
      }
    };

    const deleteFile = (name: string) => {
      const index = listFileName.value.findIndex((x) => x.nameFile === name);
      if (index >= 0) listFileName.value.splice(index, 1);
    };

    const formatFileSize = (bytes?: number) => {
      if (!bytes) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    };

    return {
      layout,
      upload,
      loadingBar,
      listFileName,
      fileChange,
      show,
      fileName,
      loadingBarProcess,
      createList,
      downLoadFile,
      idEvent,
      minDate,
      listWard,
      ward,
      index,
      listTax,
      filters,
      clearFilter,
      initFilters,
      resultStatus,
      moneyValue,
      listWardFilter,
      date,
      formatDateTime,
      taxSearch,
      loadListTax,
      downloadFile,
      exportFile,
      downLoadFileExport,
      loadingExport,
      adminPermission,
      sendMessage,
      resendMessageNotification,
      selectFile,
      deleteFile,
      formatFileSize,
      res,
      resDetail,
    };
  },
};
</script>
`r`n
